<button class="colored-text account-link-bt" kendoButton [primary]="true" [icon]="'user'" [routerLink]="linkToAccount">
  {{ userName }}
</button>
